import ManageUsersPage from './ManageUsersPage'

import UiContainer from '../../common-components/UiContainer'


export default UiContainer({
  headerText: 'Manage Users',
  containerId: 'manageUsersSection',
})(ManageUsersPage)
